import React, { Component } from "react"

/* Constants */
import { utils } from '../constants'

/* Components */
import { Chip } from "@cuba-go/poker-ui"
import { CHOICE } from "../constants/status"



/* Component Mobile Rates */
class VipMobileRate extends Component {

    getChipsList = () => {
        const { chips } = this.props
        return utils.getChips(chips)
    }

    array_length = (array) => {

        let cnt = 0

        array.forEach(item => {
            if (item) {
                cnt += 1
            }
        })

        return cnt
    }

    /* DRAW ANTE */
    _image = (index) => {

        const { ante, chips } = this.props

        const box_ante = ante[index] ? ante[index] : 0

        if (ante) {
            return (
                <div className="vip-chip-rate">
                    <Chip value={box_ante} chips={chips} size={80} />
                </div>
            )
        }
    }


    /* DRAW BET */
    _bet = (index) => {

        const { isBet, ante, gameScreen, chips } = this.props

        const ante_value = ante[index]

        const is_bet = (isBet && isBet[index]) ? isBet[index] : 0

        const style = gameScreen ? "game" : ""

        if (is_bet === 'bet') {

            if (ante_value) {
                return (
                    <div className={`vip-chip-rate vip-chip-bet ${style}`}>
                        <Chip value={ante_value * 2} chips={chips} size={60} />
                    </div>
                )
            }
        }
    }

    /* Draw Bet Result */
    _betResult = (box) => {

        const { result, ante, chips } = this.props

        const boxResult = result[box]

        // const boxResult = { betMultiplier: 3 }

        const boxAnte = ante[box]

        if (boxResult && boxResult.betMultiplier && parseInt(boxResult.betMultiplier) > 0) {

            return (
                <div className="vip-chip-bet-result-multiplier-box-mobile">

                    <div className="vip-chip-bet-result-rate-mobile">
                        <Chip value={boxAnte * 2 * parseInt(boxResult.betMultiplier)} chips={chips} size={60} />
                    </div>

                    <div className="vip-chip-bet-result-multiplier-text-mobile">{boxResult.betMultiplier}x</div>

                </div>
            )
        }

    }

    /* Draw Ante Result */
    _anteResult = (box) => {

        const { result, ante, chips } = this.props

        const boxResult = result[box]

        const ante_value = ante[box]

        if (boxResult && boxResult.anteMultiplier && parseInt(boxResult.anteMultiplier) > 0) {

            return (
                <div className="vip-chip-bet-result-multiplier-box-mobile">

                    <div className="vip-chip-ante-result-multiplier-text-mobile">{boxResult.anteMultiplier}x</div>

                    <div className="vip-chip-ante-result-rate-mobile">
                        <Chip value={ante_value} chips={chips} size={50} />
                    </div>

                </div>
            )
        }

    }



    /* DRAW BONUS CHIP */
    _bonusImage = (box) => {

        const { bonus, bonusResult, chips } = this.props

        const lose = bonusResult && bonusResult[box] && bonusResult[box].result === "lose"
        const box_bonus = (bonus && bonus[box]) ? bonus[box] : 0

        if (!lose && box_bonus) {
            return <Chip value={box_bonus} chips={chips} size={45} />
        }

        return null
    }


    /* Draw Bonus Result */
    _bonusResult = (box) => {

        const { bonusResult, chips } = this.props

        const boxResult = bonusResult ? bonusResult[box] : null

        if (boxResult && boxResult.result === "win" && parseInt(boxResult.total) > 0) {

            const multiplier = parseInt(boxResult.bonusMultiplier) === 5000 ? "JACKPOT" : `${boxResult.bonusMultiplier}x`

            return (
                <div className="vip-chip-bonus-result-box-mobile">

                    <div className="vip-chip-bonus-result-text-mobile">{multiplier}</div>

                    <div className="vip-chip-bonus-result-rate-mobile">
                        <Chip value={parseInt(boxResult.total)} chips={chips} size={45} />
                    </div>

                </div>
            )
        }
    }


    /* DRAW BONUS | джекпотная ставка, доступна только при withJackpot и при наличии ANTE на боксе */
    _bonus = (box) => {

        const { withJackpot, status, ante, bonus, bonusResult, addBonus } = this.props

        if (!withJackpot) {
            return null
        }

        const box_ante = ante[box] ? ante[box] : 0
        const box_bonus = (bonus && bonus[box]) ? bonus[box] : 0

        const choice = status === CHOICE
        const lose = bonusResult && bonusResult[box] && bonusResult[box].result === "lose"
        const active = ((choice && box_ante) || box_bonus) && !lose
        const bonus_style = box_bonus && !lose ? "hidden" : ""

        return (
            <div
                onClick={() => (choice && addBonus ? addBonus(box) : null)}
                className={`vip-chips-bottom-bonus mobile box_${box}`}
                style={{ opacity: active ? 1 : 0.5 }}
            >
                <div className={`vip-chips-bottom-bonus-text mobile ${bonus_style}`}>BONUS</div>
                {this._bonusImage(box)}
                {this._bonusResult(box)}
            </div>
        )
    }


    /* Animation Chip when opened */
    _animation = (index) => {

        const { ante, isOpen, chips } = this.props
        const box_ante = ante[index]
        const box_is_open = isOpen ? isOpen[index] : 0

        if (box_is_open) {

            if (box_ante) {
                return (
                    <div className={`vip-chip-open-animation-rate box_${index}`}>
                        <Chip value={box_ante} chips={chips} size={50} />
                    </div>
                )
            }
        }

    }


    /* Insurance */
    _insurance = (number) => {

        const { insurance, insuranceStatus, chips } = this.props

        const insuranceValue = (insurance && insurance[number]) ? insurance[number] : 0

        const insuranceResult = (insuranceStatus && insuranceStatus[number]) ? insuranceStatus[number] : 0

        let style = "vip-chip-bottom-insurance-title"
        let title = "Страховка"

        if (insuranceResult === "win") {
            style += " vip-chip-bottom-insurance-success-title"
            title = "Страховка\nвыиграла"
        }

        if (insuranceResult === "lose") {
            style += " vip-chip-bottom-insurance-fail-title"
            title = "Страховка проиграла"
        }


        if (insurance && insuranceValue && parseInt(insuranceValue) > 0) {

            const loseStyle = insuranceResult === "lose" ? "vip-chip-bottom-insurance-box vip-chip-bottom-insurance-box-lose" : "vip-chip-bottom-insurance-box"
            const boxStyle = 'right'

            return (
                <div className={`vip-chip-bottom-insurance ${boxStyle} box_${number}`}>

                    <div className={style}>
                        {title}
                    </div>

                    <div className={loseStyle}>
                        <div className="insurance-box" />
                        <Chip value={insuranceValue} chips={chips} size={50} />
                    </div>

                    {insuranceResult === "win" &&
                        <div className="vip-chip-bottom-insurance-box-win">
                            <Chip value={insuranceValue * 2} chips={chips} size={50} />
                        </div>
                    }

                </div>
            )
        }
    }


    render = () => {

        const { actions, box, add, ante, result, active, freezedBoxes, isBet, bet, activeBoxes, insurance, position } = this.props

        const box_ante = ante[box] ? ante[box] : 0

        const is_bet = (isBet && isBet[box]) ? isBet[box] : 0

        const hidden = ((!box_ante && activeBoxes > 0 && (insurance && !insurance[box])) || ((freezedBoxes && freezedBoxes[box]) && (insurance && !insurance[box]) && is_bet !== 'bet') || is_bet === 'pass' || result[box]) ? "hidden2" : ''

        const active_bet = (parseInt(box_ante) > 0 || parseInt(active) > 0 || this.array_length(ante))

        const lose = result && result[box] && result[box].result === 'lose'

        const pass = actions && actions[box] === "pass"

        const chipsShow = !pass && !lose

        return (
            <div className={`vip-chips-list mobile ${position}`}>
                <div className={`vip-chips-bottom mobile cl${box} ${hidden}`} key={`chips_${box}`}>
                    {!active_bet ? <div className="vip-chips-bottom-box">{box + 1} - БОКС</div> : null}

                    {this._animation(box)}

                    {/* <div className="vip-chips-bottom-shadow" /> */}
                    {add !== undefined && add !== null &&
                        <div onClick={() => add(box)} className={active_bet ? `vip-chips-bottom-ante mobile box_${box} vip-chips-bottom-ante-click` : `vip-chips-bottom-ante ${position} box_${box}`}>
                            <div className="vip-chips-bottom-ante-text">ANTE</div>
                            {chipsShow ? this._image(box) : null}
                            {this._anteResult(box)}
                        </div>
                    }

                    <div onClick={() => bet(box)} className={is_bet === 'bet' ? `vip-chips-bottom-bet-click vip-chips-bottom-bet mobile` : `vip-chips-bottom-bet mobile`}>
                        <div className="vip-chips-bottom-bet-text mobile">BET</div>
                        {chipsShow ? this._bet(box) : null}
                        {this._betResult(box)}
                    </div>

                    {this._bonus(box)}

                    {this._insurance(box)}

                </div>
            </div>
        )
    }

}

export default VipMobileRate